import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.5 9.375c0 1.283-.586 2.43-1.505 3.186a6.376 6.376 0 013.734 6.334c-.028.352-.335.605-.688.605-.47 0-.816-.441-.796-.911a4.875 4.875 0 10-9.74 0c.02.47-.325.911-.796.911-.353 0-.66-.253-.688-.605a6.376 6.376 0 013.734-6.333A4.125 4.125 0 1119.5 9.375zM15.375 12a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25z",
  clipRule: "evenodd"
}), React.createElement("path", {
  fillRule: "evenodd",
  d: "M9 10.875a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm-1.95 3.374l.075.001a3.375 3.375 0 10-2.313-.917 4.874 4.874 0 00-2.529 4.865c.039.327.33.552.658.552.488 0 .833-.491.812-.98a3.375 3.375 0 013.297-3.52z",
  clipRule: "evenodd"
})), "IconPeoples");